const { logError } = require('../logger')

const TreeNode = function ( actor, battleState, altNode ) {
	this.branches = [];
	this.actor = actor;
	this.battleState = battleState;
	this.altNode = altNode;
	
	const destroyBranches = () => {
		if( this.branches ) {
			for( var i = 0; i < this.branches.length; ++i ) {
				if( this.branches[i] && this.branches[i].dispose ) {
					this.branches[i].dispose();
				}
			}
			this.branches = null;
		}
	};

	this.dispose = function() {
    try { 
  		this.actor = null;
  		this.battleState = null;
  		this.altNode = null;
		
			destroyBranches()			
		
  		if( altNode ) {
  			altNode.dispose();
  			altNode = null;
  		}
    } catch (err) {
      logError(err, {
        module: 'TreeNode',
        func: 'dispose'
      })
    }
	}

	this.query = function() {
		return null
	}
}
module.exports = TreeNode
